import { reasonsNames } from './constants';

export const shouldDisplayFeedbackForm = (id: string) => id === reasonsNames.tech_issue || id === reasonsNames.other;
